import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
    products: {},
    bundles: {},
    currency: {},
    reductions: { data: [] },
    currentProduct: {},
    totalAmount: 0,
    amountDonated: { amount: 0, digit: false },
    checkoutMode: '',
    note: '',
    payments: [],
    currentCart: 0,
    cartIndices: [0],
    paymentMethods: [],
    loyaltyRewardId: null,
    loyaltyRewardLabel: '',
    loyaltyRewardType: '',
    loyaltyRewardValue: 0,
    loyaltyRewardProduct: null,
    discount: 0,
    // vente à crédit et échéance choisie (gardées en allant choisir le client)
    credit: false,
    creditDueDate: '',
    // bon de commande chargé dans ce panier ({ id, reference }) : payé par la vente
    orderForm: null,
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations,
}
